<div class="task__sidenav__white">
  <div class="task__sidenav__white__content">
    <task-sidenav-white-content
      (onSubmit)="submitForm()"
      [hidden]="
        !((service.isPreview && !!service.task) || service.isCreation || (service.isEdit && !!service.task))
      "
    />
  </div>

  <div
    class="sticky-footer d-flex justify-content-between"
    *ngIf="
      shouldShowInlineSaveFooter ||
      service.isCreation ||
      (service.isEdit && !!service.task && (service.hasProcessTaskContext || service.isConfigChange))
    "
  >
    <app-button
      (onClick)="shouldShowInlineSaveFooter ? discardInlineChanges() : service.discardSaving()"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_SECONDARY_BLUE_BACKGROUND,
        text: 'Projects.discard' | translate
      }"
    />

    <app-button
      (onClick)="submitForm()"
      [disabled]="(service.loading && !shouldShowInlineSaveFooter) || !!service?.task?.isDeleted"
      [loading]="service.loading"
      [config]="{
        size: ButtonSize.LARGE,
        type: ButtonTypes.NEW_PRIMARY_BLUE,
        text: 'Projects.saveAndEnd' | translate
      }"
    />
  </div>
</div>
